
    module.exports = function cssToMuiLoader(theme) {
      
      return {
        
        'snackbar': {'anchorOriginVertical': `top`,'anchorOriginHorizontal': `center`,},'iconButton': {'color': `inherit`,'ariaLabel': `Close`,'justifyContent': `flex-start`,'marginBottom': `16px`,},'root': {'backgroundColor': `#edc9c9`,'color': `red`,'width': `100%`,'flexWrap': `nowrap`,},'warningIcon': {'marginRight': `12px`,},'messageContainer': {'display': `flex`,'justifyContent': `space-between`,},'messageText': {'color': `red`,'fontSize': `16px`,'paddingTop': `4px`,},
        
      };
    };
  